import { useState } from "react";
import "./Counter.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus } from "@fortawesome/free-solid-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faArrowRotateLeft } from "@fortawesome/free-solid-svg-icons";

const Counter = () => {
  const [count, setCount] = useState(0);

  const decreament = () => {
    if (count > 0) {
      setCount(count - 1);
    }
  };

  const increment = () => {
    setCount(count + 1);
  };

  const reset = () => {
    setCount(0);
  };

  return (
    <div className="counter-box">
      <button onClick={decreament}>
        <FontAwesomeIcon icon={faMinus} /> Decrement
      </button>

      <span>{count}</span>

      <button onClick={increment}>
        <FontAwesomeIcon icon={faPlus} /> Increment
      </button>
      <button className="reset-btn" onClick={reset}>
        <FontAwesomeIcon icon={faArrowRotateLeft} /> Reset
      </button>
    </div>
  );
}

export default Counter;
